import React, {useState, useEffect, useMemo, useRef} from 'react';
import {myService} from '@app/services/donhangService';
import {alertService} from '@app/services/alertService';
import {useLocation} from 'react-router-dom';
import * as mainService from '@app/services/mainService';
import {getControllerName} from '@app/utils/helpers';
import {
    image_root,
    INIT_ROLE_MENU,
    PAGES_SIZE_DEFAULT
} from '@app/const/AppSetting';
import HeaderClick from '@app/utils/HeaderClick';
import {useTranslation} from "react-i18next";
import {Card, HRTag} from "@components";
import {Button, Modal} from "react-bootstrap";
import {saveAs} from 'file-saver';
import {ClipLoader} from "react-spinners";
import NewDatePicker from "@pages/FUtil/NewDatePicker";
import KhachhangListComponent from "@pages/FUtil/KhachhangListComponent";
import LoaidonhangListComponent from "@pages/FUtil/LoaidonhangListComponent";
import NhanvienAllListComponent from "@pages/FUtil/NhanvienAllListComponent";

const ExportNhanvienReport = ({ history }) => {
    const [t] = useTranslation();
    const pageSizes = PAGES_SIZE_DEFAULT;
    const [pageSize, setPageSize] = useState(pageSizes[0]);
    const location = useLocation();
    const currController = getControllerName(location.pathname);
    const [hasRole, setHasRole] = useState(false);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);

    const now = new Date();
    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
// Code khuyến nghị - tránh vấn đề timezone
    const getCurrentMonthRange = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth(); // 0-11

        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);

        // Format thủ công để tránh vấn đề timezone
        const formatDate = (date) => {
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, '0');
            const d = String(date.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        };

        return {
            tu_ngay: formatDate(firstDay),  // 2025-06-01
            den_ngay: formatDate(lastDay)   // 2025-06-30
        };
    };

    const initialSearchItems = {
        ...getCurrentMonthRange(),
        nhanvien_fk: null
    };

    const [searchItems, setSearchItems] = useState(initialSearchItems);
    const [loading, setLoading] = useState(true);
    const [loadingTicket, setLoadingTicket] = useState(false);
    const [page, setPage] = useState(1);

    const onchangeInput2 = (name, e) => {
        setLoadingTicket(true);
        let value = e?.target?.value ?? e;
        let search = {
            ...searchItems,
            [name]: value
        };
        setSearchItems(search);
        setLoadingTicket(false);
    };

    const onSelectedChangeFilter = async (name, e) => {
        setLoadingTicket(true);
        let search = searchItems;
        search = { ...search, [name]: e ? e.value : '' };
        setSearchItems(search);
        setLoadingTicket(false);
    };

    const createRs = async () => {
        setLoading(true);
        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);
            setRoleMenu(role);
            setHasRole(true);
        }
        setLoading(false);
    }

    const onChangeInput = (e) => {
        const {name, value} = e.target;
        setSearchItems((prevState) => ({
            ...prevState,
            [name]: value
        }));

    };

    useEffect(async () => {
        await mainService.checkRole({
            pathname: location.pathname,
            isAddMode: false,
            currController,
            history
        });
        //console.log('currController:'+currController);
        await createRs();
    }, []);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }

    const excelHD = async () => {
        setLoading(true);

        await myService.excelNhanvien(page, pageSize, searchItems).then((d) => {
            // Tạo filename với ngày giờ đầy đủ (YYYYMMDD_HHMMSS)
            const now = new Date();
            const currentDate = now.getFullYear() +
                String(now.getMonth() + 1).padStart(2, '0') +
                String(now.getDate()).padStart(2, '0') + '_' +
                String(now.getHours()).padStart(2, '0') +
                String(now.getMinutes()).padStart(2, '0') +
                String(now.getSeconds()).padStart(2, '0');

            const filename = `Baocaonhanvien_${searchItems.loaidonhang_fk || 'export'}_${currentDate}.xlsx`;

            const blob = new Blob([d.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            saveAs(blob, filename);
        }).catch(alertService.error);

        setLoading(false);
    };

    return !loading && (
        <div className="card card-primary">
            <HeaderClick
                isIndex
                headerName={roleMenu.tenmenu}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                <Card title={t('fields.label.boloctimkiem')} isDefaultActive>
                    <div className="card-body">
                        <div className="form-row small">
                            <div className="form-group-sm col-sm-2">
                                <label >Từ ngày</label>
                                <NewDatePicker required = "required" className="form-control w-100" isV2 id="tu_ngay" name="tu_ngay" value={searchItems.tu_ngay} onDayChange={(date) => onchangeInput2("tu_ngay", date)} />
                            </div>
                            <div className="form-group-sm col-sm-2">
                                <label >Đến ngày</label>
                                <NewDatePicker required = "required" className="form-control w-100" isV2 id="den_ngay" name="den_ngay" value={searchItems.den_ngay} onDayChange={(date) => onchangeInput2("den_ngay", date)} />
                            </div>
                            <div className="form-group col-md-2">
                                <NhanvienAllListComponent name='nhanvien_fk' labelName='Nhân viên' nhanvien_fk={searchItems.nhanvien_fk}
                                                          onChange={(opt) => onChangeInput({ target: { name: "nhanvien_fk", value: opt?.value } })} />
                            </div>

                        </div>
                    </div>
                    <div className="card-footer">
                            <Button type="button" className="btn btn-primary mr-1" onClick={() => { excelHD(); }}>
                                <i className="fa fa-file-excel"> {`Excel`}</i>
                            </Button>
                    </div>
                </Card>

                <HRTag title={t('fields.label.ketqua') + ' - '+ t('fields.label.list')}/>
            </div>
        </div>
    );
};

export default ExportNhanvienReport;